
import { Component, Vue } from 'vue-property-decorator';
import { readLoginError, readLoginErrorMessage } from '@/store/main/getters';
import { dispatchLogIn } from '@/store/main/actions';
import { apiUrl } from '@/env';

@Component
export default class SigninPage extends Vue {

  // sign in buttons
  public isLoading = false;

  // form
  public isFormValid = false;
  public email = '';
  public password = '';

  // rules
  public emailRules = [
    v => !!v || this.$t('login.emailRequired'),
    v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || this.$t('login.emailInvalid'),
  ];

  public passwordRules = [
    v => !!v || this.$t('login.passwordRequired'),
  ];

  // form error
  public error = false;
  public errorMessage = '';

  public errorProvider = false;
  public errorProviderMessages = '';

  // show password field
  public showPassword = false;


  public async submit() {
    this.isLoading = true;
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      await this.signIn(this.email, this.password);
    }
    this.isLoading = false;
    return;
  }

  public async signIn(email, password) {
    await dispatchLogIn(this.$store, {username: email, password: password});
    if (readLoginError(this.$store)) {
      this.error = true;
      this.errorMessage = readLoginErrorMessage(this.$store);
    }
    return;
  }

  public get getSSOUrl() {
    return `${apiUrl}/api/v1/sso/login/`;
  }

  public resetErrors() {
    this.error = false;
    this.errorMessage = '';

    this.errorProvider = false;
    this.errorProviderMessages = '';
  }
}
